export const getLineItemsAmountText = (idsCount: number): string => `${idsCount} Line Item${idsCount !== 1 ? 's' : ''}`;
